<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import {mapGetters,mapActions} from 'vuex'

/**
 * Advanced table component
 */
export default {
  page: {
    title: "My shift reports",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "My shift reports",
      items: [
        {
          text: "Doctor Section",
          href: "#/",
        },
        {
          text: "Shift Report",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100,200,1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "index",
          sortable: true,
            label: "S/N",
        },
        {
          key: "addedBy.name",
          sortable: true,
           label: "NAME",
        },
        {
          key: "startTime",
          sortable: true,
           label: "START TIME",
        },
         {
          key: "endTime",
          sortable: true,
           label: "END TIME",
        },
        
          {
          key: "dateCreated",
          sortable: true,
           label: "ADDED ON",
        },
        {
   sortable: false,
 key: "actions",
 label: "ACTIONS",
        } 
      ],
    };
  },
  computed: {
      ...mapGetters('reports',['personalShiftReport']),


    /**
     * Total no. of records
     */
   
    rows() {
      return this.personalShiftReport ? this.personalShiftReport.length :1;
    },

    /**
     * Todo list of records
     */
   
  },
  mounted() {
   
    // Set the initial number of items
    this.totalRows = this.personalShiftReport ? this.personalShiftReport.length :1;
   
  },
  methods: {
      yes(dd){
   alert(dd)
    },
     ...mapActions({
  FetchPersonalShiftReport: 'reports/fetchPersonalShiftReport',
}),
    /**
     * Search the table data with search input
     */
     onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    
  },
  created() {
    this.FetchPersonalShiftReport()
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="personalShiftReport"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered">
      <template #cell(index)="data">
        {{ data.index + 1 }}
      </template>
      <template #cell(actions)="data">
           <button class="btn btn-primary btn-sm  m-1 " @click="yes(data)">Comment</button>
        <button class="btn btn-info btn-sm" @click="yes(data)">Details</button>
      </template>
              </b-table>
               <center> <h3 v-if="!personalShiftReport" class="text-primary"> <b-spinner
                class="m-0"
                variant="primary"
                role="status"
              ></b-spinner> Please wait...</h3></center>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
